﻿import type { Dictionary } from "@/lib/i18n/dictionaries/en";

const ptBR: Dictionary = {
  nav: {
    home: "Início",
    map: "Mapa",
    tracker: "Rastreador",
    resources: "Recursos",
    fish: "Peixes",
    insects: "Insetos",
    birds: "Pássaros",
    foraging: "Coleta",
    crops: "Plantações",
    flowers: "Flores",
    animals: "Animais",
    recipes: "Receitas",
    locations: "Locais",
    npcs: "NPCs",
    shops: "Lojas",
    guides: "Guias",
    news: "Notícias",
    achievements: "Conquistas",
    weather: "Clima",
    events: "Eventos",
    pets: "Pets",
    dailyChecklist: "Checklist Diária",
    codes: "Códigos de Presente",
    winterTracker: "Rastreador de Inverno",
    support: "Apoiar",
    about: "Sobre",
    furniture: "Mobília",
    wardrobe: "Guarda-roupa",
    buildings: "Construção",
    resourcesCollection: "Coleção",
    resourcesDecorate: "Decorar",
    resourcesExplore: "Explorar",
    resourcesLearn: "Aprender",
    menu: "Menu",
  },
  search: {
    placeholder: "Buscar em tudo…",
    categoryItems: "Coleção",
    categoryNpcs: "NPCs",
    categoryLocations: "Locais",
    categoryGuides: "Guias",
    categoryNews: "Notícias",
    categoryAchievements: "Conquistas",
    noResults: "Nenhum resultado encontrado",
    noResultsHint: "Tente outro termo de busca",
    navigate: "navegar",
    select: "selecionar",
    close: "fechar",
  },
  language: {
    title: "Idioma",
    subtitle: "Escolha seu idioma preferido",
  },
  footer: {
    description:
      "Um guia de campo feito por jogadores para Heartopia — rotas, receitas, locais e progresso de coleção.",
    quickLinks: "Links Rápidos",
    collection: "Coleção",
    copyright: "Heartopia Hub",
    disclaimer: "Não afiliado aos desenvolvedores de Heartopia.",
  },
  home: {
    badge: "Companheiro não oficial de Heartopia",
    titleStop: "Pare de",
    titleWandering: "vagar.",
    titleStart: "Comece a planejar.",
    description:
      "O Heartopia.guide reúne o mapa da ilha, receitas, criaturas, NPCs e progresso de coleção em um só lugar, calmo e rápido.",
    openAtlas: "Abrir atlas",
    tracker: "Rastreador",
    statCatalogued: "Itens catalogados",
    statLayers: "Camadas do mapa",
    statFree: "Sempre grátis",
    islandAtlas: "Atlas da ilha",
    mapLayerNpcs: "NPCs",
    mapLayerShops: "Lojas",
    mapLayerAnimals: "Animais",
    mapHeading: "Ilha de Heartopia",
    mapNearby: "por perto",
    openMap: "Abrir mapa",
    meetLocals: "Conheça os moradores",
    hintNpcs: "NPCs prontos para conversar, mapeados de relance.",
    hintShops: "Todas as lojas abastecidas e prontas pra navegar.",
    hintAnimals: "Animais selvagens vagando por seus pontos de sempre.",
    explore: "Explorar",
    recipesPill: "Receitas",
    recipesTitle: "Cozinhe melhor",
    recipesDescription: "Navegue por pratos, cadeias de ingredientes e progresso de coleção sem abrir dez abas.",
    viewRecipes: "Ver receitas",
    ingr: "ingr.",
    profit: "lucro",
    animalsPill: "Animais selvagens",
    animalsTitle: "Conheça todos",
    animalsDescription: "Comidas favoritas, janelas de clima e dicas de mapa para cada animal selvagem.",
    viewAnimals: "Ver animais",
    guidesPill: "Guias",
    guidesTitle: "Escolha um foco",
    guidesDescription: "Três caminhos de entrada — vá direto ao guia que combina com o que você está buscando agora.",
    allGuides: "Todos os guias",
    exploreGuide: "Ver guia",
  },
  guides: {
    pillLabel: "Guias de Campo",
    titleLearn: "Aprenda",
    titleAccent: "Cada Sistema",
    searchPlaceholder: "Buscar guias…",
    categoryAll: "Todos",
    categoryBeginner: "Iniciante",
    categoryCrafting: "Artesanato",
    categoryCooking: "Culinária",
    categoryFishing: "Pesca",
    categoryExploration: "Exploração",
    difficultyEasy: "Fácil",
    difficultyMedium: "Médio",
    difficultyHard: "Difícil",
    allGuides: "Todos os guias",
    by: "Por",
    minRead: "min de leitura",
    noResults: "Nenhum guia encontrado. Tente outra busca ou categoria.",
    relatedGuides: "Guias relacionados",
    readGuide: "Ler guia",
  },
  news: {
    pillLabel: "Notícias de Heartopia",
    titleWhats: "O que há de",
    titleAccent: "Novo",
    searchPlaceholder: "Buscar notícias…",
    categoryAll: "Todas",
    categoryEvent: "Evento",
    categoryUpdate: "Atualização",
    categoryGuide: "Guia",
    categoryNews: "Notícia",
    featured: "Destaque",
    allNews: "Todas as notícias",
    read: "Ler",
  },
  map: {
    controls: "Controles do mapa",
    zoomIn: "Aproximar",
    zoomOut: "Afastar",
    resetMap: "Redefinir mapa",
    fullscreen: "Tela cheia",
    viewDetails: "Ver detalhes",
    viewLocation: "Ver local",
    openFullMap: "Abrir mapa completo",
    seeMore: "Ver mais",
    close: "Fechar",
    back: "Voltar",
    guide: "Guia",
    searchPlaceholder: "Buscar NPCs, lojas, passaros, peixes...",
    clearSearch: "Limpar busca",
    area: "Area",
    mapArea: "Area do mapa",
    event: "Evento",
    resource: "Recurso",
    location: "Local",
    npc: "NPC",
    shop: "Loja",
    busStop: "Ponto de onibus",
    wildAnimal: "Animal selvagem",
    focus: "Focar",
    hide: "Ocultar",
    show: "Mostrar",
    showAllShops: "Mostrar todas as lojas",
    showAllAnimals: "Mostrar todos os animais",
    showBugAreas: "Mostrar areas de insetos",
    showBirdAreas: "Mostrar areas de passaros",
    showResources: "Mostrar recursos no mapa",
    showEvents: "Mostrar eventos no mapa",
    showFishAreas: "Mostrar areas de peixes",
    viewAnimalAreas: "Ver areas dos animais",
    clickToView: "Clique para ver",
    spots: "pontos",
    meteorShower: "Chuva de meteoros",
    foundIn: "Encontrado em",
    more: "mais",
    sectionsNpcs: "NPCs",
    sectionsShops: "Lojas",
    sectionsBusStops: "Pontos de onibus",
    sectionsAnimals: "Animais",
    sectionsBugs: "Insetos",
    sectionsBirds: "Passaros",
    sectionsResources: "Recursos",
    sectionsWeather: "Clima",
    sectionsEvents: "Eventos",
    sectionsFish: "Peixes",
    shopClothes: "Roupas",
    shopFurniture: "Moveis",
    shopPets: "Pets",
    shopBookstore: "Livraria",
    helpTitle: "Como usar o mapa",
    helpSearchLead: "Busque",
    helpSearchText: "por qualquer NPC, loja, criatura ou area usando a barra no topo.",
    helpLayersLead: "Camadas",
    helpLayersText:
      "na lateral alternam o que aparece no mapa: NPCs, lojas, animais, recursos e mais. Toque em uma categoria para abrir a lista completa.",
    helpClickLead: "Clique em um marcador, area ou item da lista",
    helpClickText:
      "para ver as informacoes basicas no cartao inferior do mapa, com botao para abrir a pagina completa quando existir.",
  },
  locations: {
    title: "Locais",
    subtitleSuffix: "locais por toda a Ilha de Heartopia",
    openMap: "Abrir Mapa",
    searchPlaceholder: "Buscar locais…",
    allLocations: "Todos os Locais",
    npcsHere: "NPCs Aqui",
    shopsHere: "Lojas Aqui",
    listings: "itens à venda",
    foundHereTitle: "Encontre Aqui",
    foundHereHint: "Criaturas e recursos que você pode coletar neste ponto.",
    onTheMapTitle: "No Mapa",
    sameRegionTitle: "Mais na região {region}",
    statNpcs: "NPCs",
    statShops: "Lojas",
    statCollectibles: "Coletáveis",
    levelShort: "Nv. {level}",
    eventOnly: "Evento",
    seeListings: "Ver itens à venda",
    seeAll: "Ver todos",
    timeOfDay: "Período do dia",
    nothingHereTitle: "Nada registrado aqui ainda",
    nothingHereBody:
      "Não temos criaturas, lojas ou NPCs registrados neste ponto. Se você encontrou algo aqui, o mapa é o caminho mais rápido para nos mostrar onde.",
    regionTown: "Cidade",
    regionNature: "Natureza",
    regionAdventure: "Aventura",
    regionCoast: "Litoral",
    regionSea: "Mar",
    regionRegion: "Região",
    regionFishingVillage: "Vila de Pescadores",
    regionForest: "Floresta",
    regionMountain: "Montanha",
    regionBeach: "Praia",
    regionOther: "Outros",
  },
  catalog: {
    howItWorks: "Como funciona",
    fishPill: "Enciclopédia de Pesca",
    fishTitlePrefix: "Pesque",
    fishTitleAccent: "Cada Peixe",
    fishSearchPlaceholder: "Buscar peixes, habitat, tamanho da sombra…",
    fishSliderLabel: "Nível de Pesca",
    fishIntroTitle: "Pesca 101",
    fishIntroP1:
      "Jogue sua linha perto do habitat de um peixe para pescá-lo — o tamanho da sombra indica o que está fisgando.",
    fishIntroP2:
      "Nível de pesca mais alto libera capturas mais raras, e a qualidade em estrelas multiplica seu preço de venda.",
    fishUnknownHabitat: "Águas desconhecidas",
    fishHabitat: "Habitat",
    fishNoResultsTitle: "Nenhum peixe encontrado",
    fishNoResultsBody: "Tente ajustar seus filtros.",
    fishPastEventTitle: "Peixes de Eventos Passados",
    fishHeaderTitle: "Peixes",
    fishColFish: "Peixe",
    fishColShadow: "Sombra",
    insectsPill: "Enciclopédia de Captura de Insetos",
    insectsTitlePrefix: "Capture",
    insectsTitleAccent: "Cada Inseto",
    insectsSearchPlaceholder: "Buscar insetos, habitat…",
    insectsSliderLabel: "Nível de Captura",
    insectsIntroTitle: "Captura de Insetos 101",
    insectsIntroP1: "Use sua rede de insetos perto do habitat de um inseto para capturá-lo.",
    insectsIntroP2:
      "Nível de captura mais alto libera insetos mais raros, e a qualidade em estrelas multiplica seu preço de venda.",
    insectsUnknownHabitat: "Desconhecido",
    insectsPastEventTitle: "Insetos de Eventos Passados",
    insectsHeaderTitle: "Insetos",
    insectsColInsect: "Inseto",
    birdsPill: "Enciclopédia de Observação de Pássaros",
    birdsTitlePrefix: "Aviste",
    birdsTitleAccent: "Cada Pássaro",
    birdsSearchPlaceholder: "Buscar pássaros, habitat…",
    birdsSliderLabel: "Nível de Observação",
    birdsIntroTitle: "Observação de Pássaros 101",
    birdsIntroP1: "Espere perto do habitat de um pássaro com seu arbusto de camuflagem para tirar uma foto.",
    birdsIntroP2: "Nível de observação mais alto libera espécies mais raras.",
    birdsUnknownHabitat: "Desconhecido",
    birdsPastEventTitle: "Pássaros de Eventos Passados",
    birdsHeaderTitle: "Pássaros",
    birdsColBird: "Pássaro",
    cropsPill: "Enciclopédia de Agricultura",
    cropsTitlePrefix: "Cultive",
    cropsTitleAccent: "Cada Plantação",
    cropsSearchPlaceholder: "Buscar plantações…",
    cropsIntroTitle: "Agricultura 101",
    cropsIntroP1: "Plante sementes no seu lote de fazenda e regue-as diariamente até a colheita.",
    cropsIntroP2: "Algumas plantações só crescem em certas estações — confira o selo de estação antes de plantar.",
    cropsAllSeasons: "Todas as Estações",
    cropsGrowthTime: "Tempo de Crescimento",
    cropsGrowthTimeUnknown: "Desconhecido",
    cropsGrowthTimeMinutesSuffix: "min",
    cropsSortGrowthTime: "Tempo de Crescimento",
    cropsHeaderTitle: "Plantações",
    cropsColCrop: "Plantação",
    cropsColSeason: "Estação",
    flowersPill: "Enciclopédia de Jardinagem",
    flowersTitlePrefix: "Cultive",
    flowersTitleAccent: "Cada Flor",
    flowersSearchPlaceholder: "Buscar flores…",
    flowersIntroTitle: "Jardinagem 101",
    flowersIntroP1: "Plante sementes de flores e regue-as até florescerem.",
    flowersHeaderTitle: "Flores",
    flowersColFlower: "Flor",
    furniturePill: "Catálogo de Móveis",
    furnitureTitlePrefix: "Todo",
    furnitureTitleAccent: "Móvel do Jogo",
    furnitureSearchPlaceholder: "Buscar móveis…",
    furnitureMetaDescription:
      "Todos os móveis de Heartopia — iluminação, cadeiras, mesas, camas, tapetes e decoração — filtráveis por tipo, cômodo e cor, com todas as variantes visuais e preços em ouro e Estrelas dos Desejos.",
    browseAll: "Todos",
    browseVariants: "{count} modelos",
    browseShowMore: "Mostrar mais {count}",
    browseFacetRooms: "Cômodo",
    browseFacetColors: "Cor",
    browseFacetSlots: "Peça",
    browseFacetTypes: "Tipo",
    browseFacetSets: "Coleções",
    browseCollectionsMore: "Ver todas",
    browseCollectionsLess: "Mostrar menos",
    browseCollectionPieces: "{count} peças",
    browseFavourites: "Favoritos",
    browseNoArt: "O jogo não traz imagem para este",
    browseFacetStyles: "Estilos de construção",
    buildingsPill: "Catálogo do Modo Construção",
    buildingsTitlePrefix: "Todas as",
    buildingsTitleAccent: "Peças de Construção",
    buildingsSearchPlaceholder: "Buscar portas, telhados, janelas…",
    buildingsMetaDescription:
      "Todas as peças do modo construção de Heartopia — portas, janelas, telhados, cercas, esculturas de parede e texturas de parede e piso — agrupadas por estilo de construção, com preços e todas as variantes visuais.",
    wardrobePill: "Catálogo de Roupas",
    wardrobeTitlePrefix: "Todo",
    wardrobeTitleAccent: "Look e Acessório",
    wardrobeSearchPlaceholder: "Buscar roupas…",
    wardrobeMetaDescription:
      "Todos os chapéus, blusas, calças, sapatos, bolsas e acessórios de Heartopia, filtráveis por peça e cor, com preços em ouro e Estrelas dos Desejos.",
    forageablesPill: "Enciclopédia de Coleta",
    forageablesTitlePrefix: "Encontre",
    forageablesTitleAccent: "Cada Coletável",
    forageablesSearchPlaceholder: "Buscar itens coletáveis…",
    forageablesIntroTitle: "Coleta 101",
    forageablesIntroP1: "Caminhe pela ilha e colete plantas e cogumelos silvestres conforme os encontrar.",
    forageablesEnergy: "Energia",
    forageablesSortEnergy: "Energia",
    forageablesHeaderTitle: "Coletáveis",
    forageablesColItem: "Item",
    recipesPill: "Lista de Receitas",
    recipesTitlePrefix: "Cozinhe",
    recipesTitleAccent: "Cada Prato",
    recipesSearchPlaceholder: "Buscar receitas…",
    recipesIntroTitle: "Culinária 101",
    recipesIntroP1: "Reúna ingredientes e use um fogão, forno ou grelha para cozinhar.",
    recipesIntroP2: "Nível de culinária mais alto libera receitas mais sofisticadas com margens de lucro maiores.",
    recipesSortCookingLevel: "Nível de Culinária",
    recipesSortProfit: "Lucro",
    recipesEstProfit: "Lucro Est.",
    recipesViewRecipe: "Ver receita",
    recipesHeaderTitle: "Receitas",
    recipesColDish: "Prato",
    recipesBeginnerFriendly: "Bom para Iniciantes",
    recipesBestStartersTitle: "Melhores Receitas para Começar",
    recipesBestStartersSubtitle:
      "Nível de culinária baixo, lucro sólido — boas escolhas para os primeiros desbloqueios do Hobby de Culinária.",
    npcsPill: "Diretório de Moradores",
    npcsTitlePrefix: "Conheça",
    npcsTitleAccent: "Cada NPC",
    npcsSearchPlaceholder: "Buscar NPCs…",
    npcsFilterAll: "Todos",
    npcsFilterMentors: "Mentores",
    npcsFilterShopkeepers: "Lojistas",
    npcsFilterSpecial: "Especiais",
    npcsNoResultsTitle: "Nenhum NPC Encontrado",
    npcsNoResultsBody: "Tente ajustar sua busca",
    npcsResetFilters: "Limpar Filtros",
    locationsPill: "Atlas da Ilha",
    locationsTitlePrefix: "Explore",
    locationsTitleAccent: "Cada Local",
    locationsFilterAll: "Todos",
    locationsNoResultsTitle: "Nenhum Local Encontrado",
    locationsNoResultsBody: "Tente ajustar sua busca",
    locationsResetFilters: "Limpar Filtros",
    shopsPill: "Diretório de Lojas",
    shopsTitlePrefix: "Cada",
    shopsTitleAccent: "Loja da Cidade",
    shopsRunBy: "Administrada por:",
    shopsAt: "Em",
    shopsItemsForSale: "itens à venda",
    shopsSearchPlaceholder: "Buscar lojas, NPCs, locais…",
    shopsNoResultsTitle: "Nenhuma Loja Encontrada",
    shopsNoResultsBody: "Tente ajustar sua busca",
    shopsResetFilters: "Limpar Filtros",
    animalsBadge: "Guia de Animais Selvagens",
    animalsTitlePrefix: "Conheça",
    animalsTitleAccent: "Cada Animal",
    animalsPastEvent: "Evento passado",
    animalsPastEventTitle: "Animais de Eventos Passados",
    trackerBadge: "Progresso da coleção",
    trackerTitle: "Rastreador de Heartopia",
    trackerDescription:
      "Marque peixes, insetos, pássaros, plantações, flores, coletáveis, receitas e animais selvagens como coletados. O progresso é salvo neste navegador.",
    trackerMetaDescription:
      "Acompanhe o progresso da sua coleção de peixes, insetos, pássaros, plantações, flores, coletáveis, animais e receitas em Heartopia.",
    trackerCategoryTitle: "Rastreador de {category}",
    trackerCategoryMetaDescription:
      "Acompanhe o progresso da sua coleção de {category} em Heartopia — veja o que já pegou, cultivou ou cozinhou, e o que ainda falta.",
    trackerTotal: "Total",
    trackerExport: "Exportar",
    trackerImport: "Importar",
    trackerReset: "Redefinir",
    trackerImportComplete: "Importação concluída.",
    trackerImportFailed: "Falha na importação.",
    trackerSearchPlaceholder: "Buscar na coleção...",
    trackerAllCategories: "Todas as categorias",
    trackerAllItems: "Todos os itens",
    trackerCollected: "Coletados",
    trackerMissing: "Faltando",
    trackerNoResults: "Nenhum item da coleção corresponde aos filtros atuais.",
  },
  genericDetail: {
    subtitle: "Item da enciclopédia",
    sellPrice: "Preço de venda",
    energy: "Energia",
    whereToBuy: "Onde comprar",
    tags: "Tags",
    crafted: "Fabricado",
    aliases: "Também conhecido como",
    howToObtain: "Como obter",
    growsInto: "Vira",
    universalIngredientTitle: "Ingrediente culinário versátil",
    universalIngredientBody: "Pode ser usado no lugar de qualquer ingrediente ao preparar uma receita.",
  },
  animalDetail: {
    backLabel: "Todos os Animais",
    subtitle: "Item do Guia de Animais Selvagens",
    statLocation: "Local",
    statFavoriteWeather: "Clima Favorito",
    foundInTitle: "Onde Encontrar",
    favoriteFoodsTitle: "Comidas Favoritas",
    noPinTitle: "O local exato desse animal ainda não está marcado.",
    noPinDescription: "Ele vagueia pela área, então ainda não mapeamos um marcador fixo para ele.",
    weatherSunny: "Ensolarado",
    weatherWet: "Chuvoso",
    weatherRainbow: "Arco-íris",
    weatherSnowy: "Nevando",
    faqTitle: "Perguntas Frequentes",
  },
  cropDetail: {
    backLabel: "Todas as Plantações",
    subtitle: "Item da Enciclopédia de Agricultura",
    statGrowthTime: "Tempo de Crescimento",
    statSellPrice: "Preço de Venda",
    aboutTitle: "Sobre",
    seedCostTitle: "Custo da Semente",
    usedInRecipesTitle: "Usado em Receitas",
    sellPriceByStarTitle: "Preço de Venda por Estrela",
    faqTitle: "Perguntas Frequentes",
    shopsTitle: "Onde Comprar Sementes",
  },
  creatureDetail: {
    allBirds: "Todos os Pássaros",
    allInsects: "Todos os Insetos",
    allFish: "Todos os Peixes",
    birdSubtitle: "Item da Enciclopédia de Observação de Pássaros",
    insectSubtitle: "Item da Enciclopédia de Captura de Insetos",
    fishSubtitle: "Item da Enciclopédia de Pesca",
    statShadowSize: "Tamanho da Sombra",
    markAsObtained: "Marcar como obtido",
    shopsTitle: "Onde Comprar",
    locationsTitle: "Habitat",
    sellPriceByStarTitle: "Preço de Venda por Estrela",
    starChanceHint: "Chance de obter esta quantidade de estrelas",
    statWeightRange: "Peso",
    faqTitle: "Perguntas Frequentes",
  },
  forageableDetail: {
    backLabel: "Toda a Coleta",
    subtitle: "Item da Enciclopédia de Coleta",
    statEnergy: "Energia",
    shopsTitle: "Onde Comprar",
    locationsTitle: "Encontrado Em",
    aboutBody: "Caminhe pela ilha e colete quando encontrar na natureza.",
    faqTitle: "Perguntas Frequentes",
  },
  flowerDetail: {
    backLabel: "Todas as Flores",
    shopsTitle: "Onde Comprar Sementes",
    encyclopediaEntry: "Entrada da Enciclopédia de Jardinagem",
    colorsTitle: "Cores",
    otherColorsTitle: "Outras Cores",
    crossbreedingTitle: "Cruzamento",
    crossbreedingFact1: "Só funciona dentro da mesma espécie — uma rosa só cruza com outra rosa, nunca com uma tulipa.",
    crossbreedingFact2:
      "Flores têm um nível de estrela (1-5). Dois pais com a mesma estrela podem produzir essa mesma estrela ou a próxima; estrelas adjacentes (como 2★ e 3★) funcionam do mesmo jeito. Nada cruza através de uma diferença maior, e flores 5★ são o fim da linha — sem mais sementes.",
    crossbreedingFact3:
      "Cor não funciona como ingrediente — as cores dos pais nunca se combinam numa terceira cor. Cada cor costuma pertencer a um nível de estrela específico da sua espécie, então as cores que você consegue dependem mais do nível de estrela que você atingir do que das cores iniciais.",
    crossbreedingFact4:
      "Regar aumenta as chances, com um limite de cerca de 5 pessoas no total (você mais até 4 ajudantes), e seu nível de Jardinagem soma um bônus próprio. Os resultados saem depois do reset do servidor às 6:00.",
    crossbreedingDisclaimer:
      "As porcentagens exatas de sucesso ainda não estão documentadas publicamente em nenhum lugar confiável — avançar de nível é possível, nunca garantido.",
    faqTitle: "Perguntas Frequentes",
  },
  npcDetail: {
    backLabel: "Todos os NPCs",
    aboutTitle: "Sobre",
    funFactsTitle: "Curiosidades",
    foundInTitle: "Onde Encontrar",
    itemsForSale: "itens à venda",
    profileTitle: "Perfil",
    birthdayLabel: "Aniversário",
    zodiacLabel: "Signo",
    mbtiLabel: "MBTI",
    likesTitle: "Gostos",
    roleLabel: "Função",
    teachesLabel: "Ensina",
    forSaleLabel: "À Venda",
    townsfolkFallback: "Morador",
    townsfolkSubtitle: "Morador de Heartopia",
    itemsSuffix: "itens",
    noMapPinTitle: "O local exato desse NPC ainda não foi marcado.",
    noMapPinDescription: "Ele(a) se move ou muda de lugar, então ainda não temos um marcador fixo pra ele(a).",
    currencyGold: "ouro",
    currencyStars: "estrelas",
    currencyWishingStars: "estrelas dos desejos",
    currencyMoonlightCrystals: "cristais de luar",
    currencyHeartDiamonds: "diamantes de coração",
    currencyExhibitionPasses: "passes de exibição",
    currencyContributionMedals: "medalhas de contribuição",
    seeAllShopItems: "Ver todos os {count} itens em {shop} →",
  },
  recipeDetail: {
    faqIngredientsQuestion: "Como fazer {name}?",
    faqIngredientsAnswer: "{name} precisa de: {ingredients}.",
    faqLevelQuestion: "Qual nível de culinária preciso para {name}?",
    faqLevelAnswer: "Você precisa de nível de culinária {level} para desbloquear {name}.",
    faqSellQuestion: "Por quanto {name} vende?",
    faqSellAnswer: "{name} vende por {price} de ouro.",
    faqStarQuestion: "Quanto vale um {name} 5 estrelas?",
    faqStarAnswer: "{name} vende por {min} de ouro com 1★ e {max} com 5★ — {times}× mais no preparo perfeito.",
    faqEnergyQuestion: "Quanta energia {name} recupera?",
    faqEnergyAnswer: "{name} recupera {min} de energia com 1★ e {max} com 5★.",
    backLabel: "Todas as Receitas",
    subtitle: "Item da Lista de Receitas",
    statCookingLevel: "Nível de Culinária",
    statTool: "Ferramenta",
    statSellPrice: "Preço de Venda",
    shopsTitle: "Onde Comprar",
    aboutTitle: "Sobre",
    faqTitle: "Perguntas Frequentes",
    ingredientsTitle: "Ingredientes",
    noIngredients: "Nenhum ingrediente registrado para esta receita.",
    missingIngredientsTitle: "Nós não sabemos os ingredientes para essa receita",
    missingIngredientsCta: "Toque para adicionar",
    suggestIngredientsModalTitle: "Sugerir ingredientes",
    ingredientSearchPlaceholder: "Buscar um item…",
    ingredientQtyLabel: "Qtd.",
    addIngredientRow: "Adicionar ingrediente",
    removeIngredientRow: "Remover",
    submitIngredients: "Enviar sugestão",
    submittingIngredients: "Enviando…",
    ingredientsSuccessMessage: "Obrigado! Vamos revisar sua sugestão em breve.",
    ingredientsErrorMessage: "Não foi possível enviar agora — tente novamente mais tarde.",
    itemNotFoundCta: "Não encontrou? Sugerir um novo item",
    newItemPendingBadge: "pendente",
    suggestNewItemModalTitle: "Sugerir um novo item",
    newItemNameLabel: "Nome do item",
    newItemNamePlaceholder: "ex.: Tangerina",
    newItemKindLabel: "Categoria",
    newItemNotesLabel: "Notas (opcional)",
    newItemNotesPlaceholder: "Qualquer coisa que ajude a gente a adicionar — onde é encontrado, como é…",
    submitNewItem: "Enviar sugestão",
    submittingNewItem: "Enviando…",
    newItemSuccessMessage: "Obrigado! Vamos revisar e adicionar em breve.",
    newItemErrorMessage: "Não foi possível enviar agora — tente novamente mais tarde.",
    anyTag: "qualquer",
    possibleSubstitutesTitle: "Possíveis substitutos",
    possibleSubstitutesNote: "Todos os itens do catálogo desse tipo — a lista realmente aceita no jogo pode ser menor.",
    estIngredientCost: "Custo Est. dos Ingredientes",
    estProfit: "Lucro Est.",
    sellPriceByStar: "Preço de Venda por Estrela",
    starScalingNote: "Escala padrão de culinária (1x/1,5x/2x/4x/8x) — poucos pratos usam uma tabela diferente.",
    energyByStar: "Energia por Estrela",
    toolStove: "Fogão",
    toolOven: "Forno",
    toolPopcornServingCart: "Carrinho de Pipoca",
    toolPenguinStove: "Fogão Pinguim",
    toolBrickServingCart: "Carrinho de Tijolos",
    toolNone: "Nenhuma",
  },
  common: {
    loading: "Carregando",
    overviewTitle: "Visão Geral",
    viewDetails: "Ver detalhes",
    cards: "Cartões",
    list: "Lista",
    sort: "Ordenar",
    name: "Nome",
    level: "Nível",
    price: "Preço de Venda",
    clearFilters: "Limpar filtros",
    day: "dia",
    days: "dias",
    shadowSizeSmall: "Pequena",
    shadowSizeMedium: "Média",
    shadowSizeLarge: "Grande",
    shadowSizeGolden: "Dourada",
    usedInRecipesTitle: "Usado em Receitas",
    aboutTitle: "Sobre",
  },
  itemFaq: {
    whereToFindQuestion: "Onde encontro {name} em Heartopia?",
    whereToFindByLocationsAnswer: "{name} pode ser encontrado em {locations}.",
    whereToFindByHabitatAnswer: "{name} está associado ao habitat {habitat}.",
    levelRequiredQuestion: "Que nível eu preciso para capturar {name}?",
    levelRequiredAnswer: "Você precisa de pelo menos nível {level} para capturar {name}.",
    sellPriceQuestion: "Por quanto {name} é vendido?",
    sellPriceAnswer: "{name} é vendido por {price} de ouro.",
    sellPriceWithShadowAnswer:
      "{name} é vendido por {price} de ouro, e o tamanho da sombra dele na pesca é {shadowSize}.",
    weatherQuestion: "Que clima eu preciso para {name}?",
    weatherAnswer: "{name} aparece durante: {weather}.",
    usedForQuestion: "Para que serve {name}?",
    usedForAnswer: "{name} restaura {energy} de energia quando consumido.",
  },
  recipeFaq: {
    ingredientsQuestion: "Quais ingredientes eu preciso para {name}?",
    ingredientsAnswer: "{name} precisa de: {ingredients}.",
    cookingLevelQuestion: "Que nível de culinária eu preciso para {name}?",
    cookingLevelAnswer: "Você precisa de nível {level} de culinária para desbloquear {name}.",
    sellPriceQuestion: "Por quanto {name} é vendido?",
    sellPriceAnswer: "{name} é vendido por {price} de ouro.",
  },
  itemDescription: {
    foundAtClause: "pode ser encontrado em {locations}",
    foundInHabitatClause: "está associado ao habitat {habitat}",
    requiresLevelClause: "exige pelo menos o nível {level} para ser obtido",
    sellsForClause: "é vendido por {price} de ouro",
    restoresEnergyClause: "restaura {energy} de energia ao ser consumido",
    joinWord: "e",
  },
  starTooltip: {
    profitTitle: "Multiplicadores por Estrela",
    profitSubtitle: "Lucro por classificação de estrela",
    profitFooterLabel: "1★ Lucro",
    sellPriceTitle: "Multiplicadores por Estrela",
    sellPriceSubtitle: "Preço de venda por classificação de estrela",
    sellPriceFooterLabel: "1★ Preço de Venda",
  },
  mastery: {
    trackFishing: "Maestria de Pesca",
    trackBugCatching: "Maestria de Insetos",
    trackBirdwatching: "Maestria de Observação de Aves",
    trackFarming: "Maestria de Agricultura",
    trackCooking: "Maestria de Culinária",
    unitCatches: "capturas",
    unitCaptures: "registros",
    unitHarvests: "colheitas",
    unitPreparations: "preparos",
    rankNovice: "Novato",
    rankExpert: "Especialista",
    rankMaster: "Mestre",
    trophyUnlocked: "Troféu",
    footerHint: "Toque em um nível para marcar seu progresso. Chegue a Mestre para desbloquear o troféu.",
    unknownBody: "Ainda não sabemos as metas de maestria deste item.",
    unknownCta: "Você sabe quais são? Conte pra gente",
    suggestFieldLabel: "Meta de maestria Novato",
    suggestHint: "Só o número de Novato — em todos os itens confirmados, Especialista é 3x e Mestre 6x esse valor.",
  },
  statSuggestion: {
    unknownLabel: "Ainda não sabemos",
    suggestValueCta: "Sugerir um valor",
    explainer:
      "Ainda não confirmamos essa informação. Se você sabe o valor por jogar o jogo, compartilhe abaixo — toda sugestão é revisada antes de entrar no site, então não precisa ter 100% de certeza.",
    genericHint: "Só o número, sem precisar de formatação.",
    energyHint: "A quantidade de energia restaurada ao consumir este item.",
    sellPriceHint: "O preço de venda base (1 estrela), em Gold — a gente calcula o resto a partir dele.",
    habitatHint: "Onde é encontrado — o nome do local ou área.",
    growthTimeHint: "Em minutos (ex: 90 para 1h30m, 1440 para 1 dia).",
    valueLabel: "Valor",
    customOption: "Outro (digite o seu)",
    habitatTranslationFieldLabel: "Nome do habitat neste idioma",
    habitatTranslationHint: "Como esse local/área é chamado neste idioma.",
    submitButton: "Enviar sugestão",
    submitting: "Enviando…",
    successMessage: "Obrigado! Vamos revisar sua sugestão em breve.",
    errorMessage: "Não foi possível enviar agora — tente novamente mais tarde.",
  },
  imageSuggestion: {
    triggerLabel: "Sugerir uma imagem",
    triggerLabelReplace: "Sugerir uma imagem diferente",
    fieldLabel: "Sugerir uma imagem",
    explainer:
      "Ainda não temos uma imagem confirmada pra isso. Envie uma que você tenha — toda sugestão é revisada antes de entrar no site.",
    explainerReplace:
      "Acha que essa imagem está errada ou podia ser melhor? Envie uma que você tenha — toda sugestão é revisada antes de substituir a imagem atual.",
    pickFile: "Escolha uma foto (JPEG, PNG ou WebP)",
    hint: "Máximo 5MB. Confirme que a imagem é realmente desse item.",
    invalidType: "Só aceitamos imagens JPEG, PNG ou WebP.",
    tooLarge: "A imagem precisa ter no máximo 5MB.",
    submitButton: "Enviar imagem",
    submitting: "Enviando…",
    successMessage: "Obrigado! Vamos revisar sua imagem em breve.",
    errorMessage: "Não foi possível enviar agora — tente novamente mais tarde.",
  },
  generalFeedback: {
    triggerLabel: "Algo errado? Sugira uma correção",
    fieldLabel: "O que está errado?",
    hint: "Descrição errada, imagem errada, qualquer coisa — nos conte o que corrigir.",
  },
  pageFeedback: {
    triggerLabel: "Reportar um problema nesta página",
    fieldLabel: "O que está errado?",
    hint: "Erro de digitação, passo quebrado, informação desatualizada — nos avise.",
    explainer:
      "Ainda não confirmamos isso. Se você notou algo errado, compartilhe abaixo — toda sugestão é revisada antes de agirmos, então não precisa ter 100% de certeza.",
    submitButton: "Enviar feedback",
    submitting: "Enviando…",
    successMessage: "Obrigado! Vamos dar uma olhada em breve.",
    errorMessage: "Não foi possível enviar agora — tente novamente mais tarde.",
  },
  mapAreaUnknown: {
    title: "Ainda não sabemos onde fica.",
    description: "Ajude a comunidade contribuindo com a localização deste item.",
    cta: "Ajude a gente a adicionar",
    fieldLabel: "Local / área",
    hint: "Descreva onde você encontrou — o nome do local e algum ponto de referência próximo.",
    notPinnedTitle: "Esse local ainda não está marcado no mapa.",
    notPinnedDescription: "Sabemos a área geral, mas ainda não mapeamos um marcador exato para ela.",
  },
  itemGuides: {
    title: "Guias Relacionados",
  },
  itemFallback: {
    badge: "Tradução pendente",
    message: "Ainda não sabemos o nome deste item neste idioma.",
    usingEnglish: "Usando o inglês:",
    helpMessage: "Ainda não sabemos o nome desse item. Quer nos ajudar?",
    helpCta: "Ajudar a traduzir",
    modalTitle: "Sugerir uma tradução",
    fieldPlaceholder: "Nome do item neste idioma",
    submitButton: "Enviar sugestão",
    submitting: "Enviando…",
    successMessage: "Obrigado! Vamos revisar sua sugestão em breve.",
    errorMessage: "Não foi possível enviar agora — tente novamente mais tarde.",
  },
  notFoundPage: {
    title: "404",
    subtitle: "Opa, esta página não foi encontrada.",
    description: "Você caiu numa área que ainda não existe em Heartopia. Bora voltar pro caminho certo.",
    primaryCta: "Voltar para o início",
    secondaryCta: "Ver mapa do mundo",
  },
  achievements: {
    pill: "Conquistas",
    titlePrefix: "Desbloqueie cada",
    titleAccent: "conquista",
    subtitle: "Acompanhe seu progresso e descubra como desbloquear cada conquista em Heartopia.",
    searchPlaceholder: "Buscar conquistas…",
    filterAll: "Todas",
    showHidden: "Mostrar ocultas",
    hideHidden: "Ocultar",
    statTotal: "Total",
    statCompleted: "Concluídas",
    statHidden: "Ocultas",
    noResultsTitle: "Nenhuma conquista encontrada",
    noResultsBody: "Tente outra busca ou filtro.",
    resetFilters: "Limpar filtros",
    lockedTitle: "???",
    lockedBody: "Esta conquista ainda é um mistério.",
    titleGainedLabel: "Título obtido",
    hintLabel: "Dica",
    notesLabel: "Notas",
    markDone: "Marcar como concluída",
    markNotDone: "Desmarcar",
    backToList: "Voltar para Conquistas",
    relatedTitle: "Conquistas relacionadas",
    faqTitle: "Perguntas Frequentes",
  },
  share: {
    title: "Compartilhar",
    shareVia: "Compartilhar via…",
    copyLink: "Copiar link",
    linkCopied: "Copiado!",
  },
  weather: {
    pill: "Estação do Clima",
    titlePrefix: "Previsão",
    titleAccent: "Heartopia",
    subtitle: "Confira as condições para planejar sua rota, identificar eventos e se preparar para spawns raros.",
    directoryTitle: "Guias de Clima e Eventos",
    specialEvent: "Evento Especial",
    openGuide: "Abrir Guia",
    backToWeather: "Voltar ao Clima",
    overviewTitle: "Visão Geral",
    checklistTitle: "Se Você Só Tem 10 Minutos",
    activitiesTitle: "Atividades Principais",
    bestForTitle: "Ideal Para",
    creaturesTitle: "Disponíveis Neste Clima",
    creaturesMore: "mais",
    creaturesShowLess: "Mostrar menos",
    noCreaturesData: "Ainda não temos criaturas marcadas para esse clima.",
    faqTitle: "Perguntas Frequentes",
  },
  events: {
    pill: "Calendário de Heartopia",
    titlePrefix: "Eventos",
    titleAccent: "Ativos",
    subtitle:
      "De grandes festivais sazonais a minigames diários rápidos, encontre tudo o que está acontecendo em Heartopia.",
    minigamesTitle: "Minigames Recorrentes",
    seasonalTitle: "Eventos Sazonais e Collabs",
    activeLabel: "Ativo",
    endedLabel: "Encerrado",
    viewEvent: "Ver Evento",
    backToEvents: "Voltar aos Eventos",
    requirementsTitle: "Requisitos",
    locationTitle: "Local",
    costTitle: "Custo de Entrada",
    freeLabel: "Grátis",
    dgLevelLabel: "Nível da Guilda dos Desenvolvedores",
    questLabel: "Missão",
    hobbyLabel: "Hobby",
    quickFactsTitle: "Resumo Rápido",
    unlockLabel: "Desbloqueio",
    npcAreaLabel: "NPC / Área",
    durationLabel: "Duração",
    typeLabel: "Tipo",
    howToStartTitle: "Como Começar",
    howItWorksTitle: "Como Funciona",
    goalsRewardsTitle: "Metas e Recompensas",
    tipsTitle: "Dicas / Estratégia",
    datesTitle: "Datas do Evento",
    overviewTitle: "Visão Geral",
    highlightsTitle: "Destaques",
    standoutRewardTitle: "Recompensa em Destaque",
    faqTitle: "Perguntas Frequentes",
  },
  pets: {
    hubBadge: "Guia de Pets",
    hubTitlePrefix: "Pets de",
    hubTitleAccent: "Heartopia",
    hubSubtitle: "Tudo que você precisa para desbloquear, adotar e cuidar de pets.",
    hubUnlockTitle: "Desbloquear Cuidado de Pets",
    hubUnlockDesc: "Geralmente no Nível 12 de Desenvolvedor/Membro via Pedidos de Moradores.",
    hubOrderTitle: "Gato Primeiro",
    hubOrderDesc: "Você precisa adotar um gato antes de os cães serem liberados.",
    hubRotationTitle: "Rotação Diária",
    hubRotationDesc: "3 gatos + 3 cães mudam todo dia no Centro de Adoção.",
    cardDogsTitle: "Cães",
    cardDogsSubtitle: "Raças • Cuidado • Grupos",
    cardDogsDesc: "37 raças com grupos de tamanho e notas de cuidado.",
    cardCatsTitle: "Gatos",
    cardCatsSubtitle: "Raças • Traços • Pelagens",
    cardCatsDesc: "18 raças com variantes de pelagem e cores.",
    cardTraitsTitle: "Traços",
    cardTraitsSubtitle: "Todos os traços + busca",
    cardTraitsDesc: "Lista pesquisável de traços e seus efeitos.",
    cardGuideTitle: "Guia",
    cardGuideSubtitle: "Desbloquear • Adotar • Cuidar",
    cardGuideDesc: "Fluxo de desbloqueio mais a rotina diária de adoção/cuidado.",
    dogsBadge: "Guia de Cães",
    dogsTitlePrefix: "Cães de",
    dogsTitleAccent: "Heartopia",
    dogsSubtitle: "Desbloqueie, adote e cuide de cães com um catálogo de raças organizado.",
    catsBadge: "Guia de Gatos",
    catsTitlePrefix: "Gatos de",
    catsTitleAccent: "Heartopia",
    catsSubtitle: "Raças, traços e cuidados — organizados e separados.",
    quickInfoRotationTitle: "Rotação Diária",
    quickInfoRotationDesc: "3 gatos + 3 cães mudam todo dia.",
    quickInfoUnlockTitle: "Desbloqueio",
    quickInfoUnlockDesc: "O Cuidado de Cães abre depois do Cuidado de Gatos.",
    quickInfoOrderTitle: "Gato Primeiro",
    quickInfoOrderDesc: "Gatos são liberados antes dos cães.",
    quickInfoTraitsTitle: "Traços Aleatórios",
    quickInfoTraitsDescDogs: "Os traços são aleatórios, não ligados à raça.",
    quickInfoTraitsDescCats: "Os traços são aleatórios e focados no comportamento.",
    searchPlaceholder: "Buscar raças…",
    filterAll: "Todas",
    filterSmall: "Pequeno",
    filterMedium: "Médio",
    filterLarge: "Grande",
    noResults: "Nenhuma raça encontrada",
    traitsBadge: "Traços de Pets",
    traitsTitlePrefix: "Todos os",
    traitsTitleAccent: "Traços",
    traitsSubtitle: "Todo traço que um pet pode ter e o que significa para o cuidado diário.",
    traitsSearchPlaceholder: "Buscar traços…",
    effectLabel: "Efeito",
    guideBadge: "Cuidado de Pets",
    guideTitlePrefix: "Guia de",
    guideTitleAccent: "Adoção",
    guideSubtitle: "Desbloqueie o cuidado de pets, adote seu primeiro gato e depois expanda para os cães.",
    guideStepsTitle: "Como Desbloquear",
    guideAdoptionTitle: "Como Funciona a Adoção",
    guideCareTitle: "Rotina Diária de Cuidados",
    backToPets: "Voltar aos Pets",
    viewBreed: "Ver Raça",
    groupLabel: "Tamanho",
    dogLabel: "Cão",
    catLabel: "Gato",
    variantsLabel: "Variantes de Pelagem Conhecidas",
    suggestTitle: "Falta uma raça ou informação?",
    suggestDogsBody: "Ajude a ampliar o catálogo de cães com uma raça, variante ou correção.",
    suggestCatsBody: "Ajude a ampliar o catálogo de gatos com uma raça, variante de pelagem ou correção.",
    suggestButton: "Sugerir item",
    suggestFieldLabel: "Informação do pet",
    suggestHint: "Conte a raça, variante, fonte ou correção que você conhece.",
    viewAllTraits: "Ver todos os traços",
  },
  dailyChecklist: {
    badge: "Rastreador Diário",
    titlePrefix: "Heartopia",
    titleAccent: "Diária",
    subtitle: "Acompanhe suas tarefas diárias, recursos e rotações de lojas. Tudo reinicia em um novo dia.",
    progressTitle: "Progresso Diário",
    progressComplete: "concluído",
    allDone: "Parabéns! Você completou todas as tarefas de hoje!",
    quickTasksTitle: "Tarefas Rápidas",
    quickTasksDesc: "Ações diárias essenciais que reiniciam todo dia.",
    shopsTitle: "Rotação de Lojas",
    shopsDesc: "Confira o estoque rotativo desses vendedores.",
    resetInfo: "Reinicia automaticamente com base na sua data local.",
    customTitle: "Tarefas Personalizadas",
    addCustom: "Adicionar",
    customPlaceholder: "Nome da tarefa…",
    customEmpty: "Nenhuma tarefa personalizada ainda.",
    remove: "Remover",
  },
  codes: {
    badge: "Central de Resgate",
    title: "CÓDIGOS",
    titleAccent: "DE PRESENTE",
    subtitle: "Resgate esses códigos no jogo para receber recompensas especiais, ouro e itens exclusivos!",
    statActive: "Ativos",
    statExpired: "Expirados",
    statTotal: "Total",
    howToTitle: "Como Resgatar",
    howToStep1: "Abra o menu do jogo",
    howToStep2: "Toque em 'Configurações' > 'Resgatar Código'",
    howToStep3: "Digite o código exatamente como mostrado",
    howToStep4: "Confirme e receba suas recompensas!",
    rewardsLabel: "Recompensas",
    noRewardsLabel: "Nenhuma recompensa listada",
    starQualityHint: "Este código entrega o item em uma qualidade de estrela específica.",
    unconfirmedRewardHint:
      "Ainda não temos este item no nosso catálogo, então este é o id bruto do jogo, e não um nome confirmado.",
    expiredText: "Este código expirou e não pode mais ser resgatado.",
    copyCode: "Copiar código",
    copied: "Copiado!",
    statusActive: "ATIVO",
    statusExpired: "EXPIRADO",
    redeemedLabel: "Resgatado",
    markRedeemed: "Marcar como resgatado",
    unmarkRedeemed: "Desmarcar resgate",
    goldLabel: "Ouro",
    starLabel: "Estrela dos Desejos",
    heartLabel: "Cristal do Luar",
    maintenanceNote:
      "Os códigos são verificados periodicamente, mas podem expirar sem aviso — se um não funcionar no jogo, provavelmente está desatualizado.",
  },
  winterTracker: {
    badge: "Diário Fashionwave",
    titlePrefix: "Rastreador de Itens",
    titleAccent: "Gelo de Inverno",
    subtitle:
      "Acompanhe todo item de edição limitada da temporada Gelo de Inverno — esse evento já encerrou, mas você ainda pode navegar pelo que estava disponível.",
    endedNote:
      "Esse evento já encerrou — os itens mostrados aqui não são mais obtidos no jogo. Mantido como referência do que estava disponível.",
    searchPlaceholder: "Buscar itens…",
    filterAll: "Todos",
    filterAccessory: "Acessórios",
    filterBag: "Bolsas",
    filterClothing: "Roupas",
    filterFurniture: "Móveis",
    filterEmote: "Emotes",
    filterVehicle: "Veículos",
    filterTool: "Ferramentas",
    filterPet: "Itens de Pet",
    filterPuzzle: "Quebra-Cabeças",
    collected: "Coletado",
    missing: "Faltando",
    noResults: "Nenhum item encontrado",
    costLabel: "Fichas Fashionwave",
    backToEvent: "Voltar ao Gelo de Inverno",
  },
  support: {
    badge: "Apoie o heartopia.guide",
    titlePrefix: "Mantenha o",
    titleAccent: "Coração",
    titleSuffix: "Batendo",
    subtitle:
      "O heartopia.guide é um projeto feito com carinho para a comunidade. Seu apoio ajuda a manter os servidores no ar e as atualizações chegando!",
    donateCta: "Apoiar o Projeto",
    donateDescription: "Cada contribuição ajuda a cobrir hospedagem, domínio e tempo de desenvolvimento.",
    creatorLabel: "Lucas Diniz",
    creatorRole: "Criador do heartopia.guide",
    creatorBadge: "Desenvolvedor & Designer",
    footerNote: "Obrigado por fazer parte dessa jornada!",
  },
  about: {
    badge: "Projeto de Fã · Não Oficial",
    title: "Sobre o Heartopia Guide",
    subtitle:
      "Heartopia Guide é um site feito pela comunidade para ajudar jogadores a encontrar informações úteis do jogo — guias, rastreadores, checklists, itens e referências de eventos — de forma rápida e organizada.",
    lastUpdatedLabel: "Última atualização",
    pillEventTrackers: "Rastreadores de Eventos",
    pillGuides: "Guias",
    pillChecklists: "Checklists",
    pillAlwaysUpdated: "Sempre Atualizado",
    whatYouFindTitle: "O que você vai encontrar aqui",
    whatYouFind1: "Rastreadores de eventos e listas de itens (quando disponíveis)",
    whatYouFind2: "Guias e páginas de referência sobre mecânicas do jogo",
    whatYouFind3: "Páginas utilitárias para facilitar rotinas diárias/semanais",
    whatYouFind4: "Um site que evolui com o tempo — atualizado conforme novas informações surgem",
    transparencyTitle: "Transparência e aviso de projeto de fã",
    transparencyP1:
      "Este é um projeto de fã independente e não oficial. Não somos afiliados, patrocinados ou endossados pelos criadores ou publicadores de Heartopia.",
    transparencyP2: "Todas as marcas, nomes e ativos pertencem aos seus respectivos donos.",
    creatorTitle: "Quem está por trás disso",
    creatorIntro: "heartopia.guide não é um projeto anônimo — é feito e mantido por uma pessoa real.",
    creatorName: "Lucas Diniz",
    creatorRole: "Criador e desenvolvedor do heartopia.guide",
    creatorLinkLabel: "lucashdo.com",
    sourcesTitle: "De onde vêm as informações",
    sourcesIntro: "As informações podem vir de:",
    sourcesItem1: "Observação e testes dentro do jogo",
    sourcesItem2: "Contribuições da comunidade",
    sourcesItem3: "Atualizações oficiais do jogo",
    sourcesNote:
      "Mesmo com cuidado, alguns dados podem estar incompletos ou desatualizados — especialmente durante eventos ativos.",
    adsTitle: "Anúncios e sustentabilidade",
    adsP1:
      "Para manter o site funcionando e cobrir custos (domínio, hospedagem, ferramentas), podemos exibir anúncios.",
    adsP2:
      "Serviços de publicidade como o Google podem usar cookies ou tecnologias parecidas para exibir e medir anúncios.",
    copyrightTitle: "Direitos autorais",
    copyrightText:
      "Se você é detentor de direitos e acredita que algum conteúdo deve ser removido ou ajustado, entre em contato com a(s) URL(s) relevante(s) e detalhes. Vamos revisar e agir o mais rápido possível.",
    contactTitle: "Contato",
    contactEmailLabel: "Email",
    footerNote: "Feito com carinho pela comunidade Heartopia",
  },
  legal: {
    lastUpdatedLabel: "Última atualização",
    lastUpdatedValue: "2026-02-13",
    contactHeading: "Contato",
    contactLinkLabel: "página Sobre & Contato",
    privacyTitle: "Política de Privacidade",
    privacyIntro:
      "Esta Política de Privacidade explica como o heartopia.guide coleta, usa e protege informações pessoais quando você acessa este site.",
    privacyDataHeading: "Dados que podemos coletar",
    privacyData:
      "Dependendo de como você usa o site, podemos coletar: dados de navegação/uso (páginas visitadas, cliques, data/hora, referência, tipo de dispositivo/navegador, idioma); identificadores técnicos (ex: IP em logs, dados de segurança e desempenho); cookies e tecnologias semelhantes (veja a Política de Cookies); e dados que você fornece (ex: se você nos enviar um email ou feedback). Não solicitamos dados sensíveis (ex: saúde, religião, biometria).",
    privacyHowWeUseHeading: "Como usamos os dados",
    privacyHowWeUse:
      "Usamos os dados para fornecer e manter o site, melhorar o conteúdo e o desempenho, prevenir abusos e fraudes, responder a mensagens e suporte, medir audiência quando habilitado, e exibir anúncios (se aplicável) e medir desempenho.",
    privacySharingHeading: "Compartilhamento",
    privacySharing:
      "Podemos compartilhar dados com prestadores de serviço (hospedagem, análise, CDN e/ou publicidade) para operar o site; quando exigido legalmente (ordens judiciais, obrigações regulatórias); e para proteger o site e os usuários. Não vendemos informações pessoais.",
    privacyRetentionHeading: "Retenção",
    privacyRetention:
      "Mantemos os dados apenas pelo tempo necessário para os fins descritos (ou conforme exigido por lei). Logs técnicos podem ser retidos por períodos limitados para segurança e diagnóstico.",
    privacyRightsHeading: "Seus direitos",
    privacyRights:
      "Você pode solicitar os direitos aplicáveis sob as leis relevantes (ex: acesso, correção, exclusão, portabilidade quando aplicável, informações sobre compartilhamento, retirada de consentimento). Para exercer seus direitos, entre em contato conosco pela página de contato com os detalhes da sua solicitação.",
    privacyAdvertisingHeading: "Publicidade",
    privacyAdvertising:
      "Usamos serviços de publicidade de terceiros, incluindo o Google AdSense. Esses provedores podem usar cookies e identificadores semelhantes para exibir anúncios, incluindo anúncios personalizados com base em suas visitas anteriores a este site e outros sites.\n\nVocê pode optar por não receber publicidade personalizada através das Configurações de Anúncios do Google e/ou AboutAds (opção de recusa de publicidade baseada em interesses). Anúncios não personalizados ainda podem ser exibidos com base em conteúdo geral e localização.",
    privacyContactBefore: "Para perguntas ou para exercer seus direitos, use nossa ",
    termsTitle: "Termos de Uso",
    termsIntro:
      'Ao acessar este site (o "Site"), você concorda com estes Termos. O Site fornece conteúdo informativo e ferramentas para a comunidade. Você concorda em usá-lo de forma legal e respeitosa.',
    termsUseHeading: "Propriedade intelectual e marcas registradas",
    termsUse:
      "O conteúdo original do Site (texto, estrutura, design) pertence ao heartopia.guide, salvo indicação em contrário. Heartopia, nomes de personagens/itens, marcas registradas e ativos referenciados pertencem aos seus respectivos donos. Conteúdo de terceiros pode aparecer para referência; se você é detentor de direitos e deseja remoção ou ajuste, entre em contato conosco.",
    termsLiabilityHeading: "Isenção e limitação de responsabilidade",
    termsLiability:
      'O Site é fornecido "como está". O conteúdo pode estar incompleto, desatualizado ou temporariamente indisponível. Não garantimos disponibilidade contínua ou precisão total. Na medida permitida por lei, não somos responsáveis por danos indiretos, perda de dados, perda de lucros ou outras perdas decorrentes do uso do Site. Podemos atualizar o Site e estes Termos a qualquer momento; o uso continuado após as alterações significa aceitação.',
    termsContactBefore: "Para perguntas ou solicitações, use nossa ",
    cookiesTitle: "Política de Cookies",
    cookiesIntro:
      "Esta Política de Cookies explica como o heartopia.guide usa cookies e tecnologias semelhantes para reconhecer visitantes e melhorar a experiência.",
    cookiesWhatAreHeading: "O que são cookies",
    cookiesWhatAre:
      "Cookies são pequenos arquivos de texto armazenados no seu navegador quando você visita um site. Eles ajudam com funcionalidade, preferências e estatísticas de uso.",
    cookiesHowWeUseHeading: "Como usamos cookies",
    cookiesHowWeUse:
      "Podemos usar cookies para: Essenciais (obrigatórios) — necessários para a funcionalidade principal do site (segurança, desempenho, preferências críticas). Preferências — ex: idioma, tema, filtros. Análise — para entender como o site é usado e melhorar o conteúdo. Publicidade (se aplicável) — parceiros podem usar cookies para medir desempenho e personalizar anúncios.",
    cookiesThirdPartyHeading: "Cookies de terceiros",
    cookiesThirdParty:
      "Podemos usar serviços de terceiros (ex: hospedagem, análise, CDNs, redes de publicidade). Esses provedores podem definir seus próprios cookies. Você pode revisar ou gerenciá-los pelo banner de consentimento do site.",
    cookiesConsentHeading: "Consentimento e controle",
    cookiesConsent:
      "Você pode controlar cookies pelo banner de consentimento exibido na sua primeira visita, configurações do navegador (bloquear ou excluir cookies), ou modo privado/anônimo. Bloquear cookies essenciais pode quebrar funcionalidades do site.",
    cookiesContactBefore: "Para perguntas sobre cookies, use nossa ",
    sitemapTitle: "Mapa do Site",
    sitemapIntro: "Principais seções e páginas do heartopia.guide.",
    sitemapXmlLabel: "sitemap.xml",
    sitemapXmlNote: "para motores de busca",
    sitemapResourcesHeading: "Recursos",
    sitemapSupportHeading: "Apoio",
    sitemapLegalHeading: "Legal",
  },
  consent: {
    bannerLabel: "Consentimento de cookies",
    message:
      "Usamos cookies para funcionalidades essenciais do site e, se você permitir, para medir o uso e exibir anúncios.",
    learnMore: "Saiba mais sobre cookies",
    acceptCta: "Aceitar tudo",
    rejectCta: "Rejeitar não essenciais",
  },
};

export default ptBR;
